import React, { useCallback, useMemo, useEffect, ChangeEvent } from 'react';
import debounce from 'lodash/debounce';

import { TextInput } from 'src/common/form/text-input';
import { CloseRegularIcon } from 'src/monet/icons';
import LoadingSpinner from 'src/common/components/loading-spinner';
import { Destination } from 'src/common/interfaces/destination.interface';
import { Nullable } from 'src/types/nullable.type';

export const EditorContentFormEmbedInput = ({
  destination,
  onChange,
  onCancel,
  loading,
  url,
  ...rest
}: {
  destination: Nullable<Destination>;
  onChange: (value: string) => void;
  onCancel: () => void;
  url?: string;
  loading?: boolean;
}) => {
  const debouncedInputChangeHandler = useMemo(() => {
    return debounce(onChange, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Stop the invocation of the debounced function after unmounting
  useEffect(() => {
    return () => {
      debouncedInputChangeHandler.cancel();
    };
  }, [debouncedInputChangeHandler]);

  const renderBtn = useCallback(() => {
    if (loading) {
      return <LoadingSpinner />;
    }
    return (
      <button type='button' className='hover:opacity-80' onClick={onCancel}>
        <CloseRegularIcon />
      </button>
    );
  }, [loading, onCancel]);

  return (
    <TextInput
      id='editor_content_form_embed_input'
      inputProps={{
        type: 'text',
        value: url || undefined,
        placeholder: destination ? `Paste ${destination.name} URL` : 'Paste a URL',
      }}
      required={true}
      autoFocus={!loading}
      branded={true}
      trailingAddon={renderBtn()}
      inputClasses='pr-12'
      onChange={(e: ChangeEvent<HTMLInputElement>) => debouncedInputChangeHandler(e.target.value)}
    />
  );
};
